export const HEADER_IS_APPAREL_RETAILER = "X-Is-Apparel";
